import styled from "styled-components";

export const ClientSettingsContentContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    background-color: ${({theme}) => theme.colors.backgroundMiddleDark};
    padding: 15px;
`